import React from 'react';

const AddEmployee=React.lazy(()=>import('./AddEmployee'));
const EmployeeList=React.lazy(()=>import('./EmployeeList'));
const EmployeeView=React.lazy(()=>import('./EmployeeView'));
const EmployeeTodoList=React.lazy(()=>import('./EmployeeTodoList'));
export {
    AddEmployee,
    EmployeeList,
    EmployeeView,
    EmployeeTodoList
}